import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { CouponDetails } from "src/api/types";
import { useSearchParams } from "react-router-dom";
import { LIMIT, PAGE } from "src/constants/searchParams";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { ChangeEvent, useMemo } from "react";
import { columns } from "../../utils/columns";
import CouponsTableRow from "../CouponsTableRow";
import TableHeaderCell from "src/shared/TableHeaderCell";

interface TableProps {
  records: CouponDetails[];
  total: number;
}

const CouponsTable = ({ records, total }: TableProps) => {
  const [params, setParams] = useSearchParams();
  const rawPage = params.get(PAGE);
  const rawLimit = params.get(LIMIT);

  //84 header + filters
  //64 gaps
  //32 top and bottom padding
  const height = useMemo(() => window.innerHeight - 84 - 64 - 32, []);

  const page = rawPage ? parseInt(rawPage, 10) : 0;
  const limit = rawLimit ? parseInt(rawLimit, 10) : ROWS_PER_PAGE[0];

  const handleChangePage = (_: unknown, newPage: number) => {
    params.set(PAGE, newPage.toString());
    setParams(params);
  };

  const handleChangeRowsPerPage = (e: ChangeEvent<HTMLInputElement>) => {
    params.set(LIMIT, e.target.value);
    setParams(params);
  };

  return (
    <Stack role="table">
      <TableContainer
        component={Paper}
        sx={{
          p: 0,
          boxShadow: "none",
          backgroundColor: "transparent",
          height: height - 52,
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              borderRadius: "8px",
              border: "1px solid var(--teal, #569099)",
            }}
          >
            <TableRow>
              {columns.map((column) => (
                <TableHeaderCell
                  column={column}
                  key={column.id}
                  default_sort={column.default_sort}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((row) => (
              <CouponsTableRow row={row} key={row.id} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ height: 52, mr: 10 }}
        component="div"
        count={total}
        page={page}
        rowsPerPage={limit}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={ROWS_PER_PAGE}
      />
    </Stack>
  );
};

export default CouponsTable;
